import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import logo from "../assets/img/boersenkusecpixabay.png";
import "./login.css";
import TurnstileWidget from "../components/TurnstileWidget";

export default function LoginPage() {
    const { login, loginAsGuest } = useAuth();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [turnstileToken, setTurnstileToken] = useState("");
    const [loading, setLoading] = useState(false);
    const [guestLoading, setGuestLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");
    const history = useHistory();

    const handleGuestLogin = async () => {
        setError(null);
        setMessage("");

        try {
            setGuestLoading(true);
            loginAsGuest();
            history.push("/admin/aktiennews");
        } catch {
            setError("Gastzugang konnte nicht gestartet werden.");
        } finally {
            setGuestLoading(false);
        }
    };

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        if (!turnstileToken) {
            setMessage("Bitte bestätige zuerst, dass du ein Mensch bist.");
            return;
        }

        try {
            setLoading(true);
            // login() übernimmt PreferredLanguage aus der AuthResponse,
            // speichert sie im AuthContext und setzt kimat-language.
            await login(userName, password, turnstileToken);
            window.location.href = "/admin/aktiennews";
        } catch (err) {
            setError(err?.message || "Username oder Passwort falsch");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-root">
            <div className="login-left">
                <img src={logo} alt="Logo" className="login-logo" />
                <span className="company-name">
                    Künstlich Intelligentes Market Analyse Tool
                </span>
            </div>

            <div className="login-divider" />

            <div className="login-right">
                <h1>Willkommen</h1>
                <p>Anmeldung K.I.M.A.T.</p>

                <form onSubmit={submit}>
                    <input
                        style={{ width: "300px" }}
                        placeholder="USERNAME"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />

                    <input
                        style={{ width: "300px" }}
                        type="password"
                        placeholder="PASSWORD"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <TurnstileWidget
                        style={{ width: "300px" }}
                        onVerify={setTurnstileToken}
                    />

                    {message && <div className="login-error">{message}</div>}
                    {error && <div className="login-error">{error}</div>}

                    <button disabled={loading || guestLoading} style={{ width: "300px" }}>
                        {loading ? "Anmelden ..." : "Anmeldung"}
                    </button>

                    <button
                        type="button"
                        disabled={loading || guestLoading}
                        style={{ width: "300px", marginTop: "12px" }}
                        onClick={handleGuestLogin}
                    >
                        {guestLoading ? "Gastzugang ..." : "Als Gast fortfahren"}
                    </button>

                    <div
                        style={{
                            width: "300px",
                            marginTop: "10px",
                            fontSize: "0.9rem",
                            lineHeight: 1.5,
                            opacity: 0.8
                        }}
                    >
                        Als Gast hast du nur Zugriff auf die Aktien-News. Profil,
                        Rollen und weitere Funktionen sind erst nach Registrierung
                        verfügbar.
                    </div>

                    <div className="login-links">
                        <Link to="/register" className="login-link">
                            Erstanmeldung
                        </Link>
                        <Link to="/forgot-password" className="login-link">
                            Passwort vergessen?
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}